import { createComponentStore } from '../../utils/createComponentStore';

const emptyTemplateData = () => ({
  subject: '',
  body: '',
  to: [],
  cc: [],
  bcc: [],
  replyTo: [],
  attachments: [],
  name: '',
});

const ensureDefaults = (templateData) => {
  const data = { ...templateData };
  if (!Array.isArray(data.to)) data.to = [];
  if (!Array.isArray(data.cc)) data.cc = [];
  if (!Array.isArray(data.bcc)) data.bcc = [];
  if (!Array.isArray(data.replyTo)) data.replyTo = [];
  if (!Array.isArray(data.attachments)) data.attachments = [];
  return data;
};

const migrateV1Data = (rawData) => {
  const data = { ...rawData };

  // v1 compat: content → body
  if (data.content && !data.body) {
    data.body = data.content;
  }
  delete data.content;

  // v1 compat: recipients.to/cc/bcc/replyTo → flat fields
  if (data.recipients) {
    if (data.recipients.to && !data.to) data.to = data.recipients.to;
    if (data.recipients.cc && !data.cc) data.cc = data.recipients.cc;
    if (data.recipients.bcc && !data.bcc) data.bcc = data.recipients.bcc;
    if (data.recipients.replyTo && !data.replyTo) data.replyTo = data.recipients.replyTo;
    delete data.recipients;
  }

  // v1 compat: attachedFiles → attachments
  if (data.attachedFiles && !data.attachments) {
    data.attachments = data.attachedFiles;
  }
  delete data.attachedFiles;

  delete data.client_name;

  return data;
};

const { getStore: getEmailStore, defaultStore } = createComponentStore({
  type: 'email',
  endpoint: 'email',
  registryKey: 'email',
  initData: emptyTemplateData,
  onLoadData: (rawData) => ensureDefaults({ ...emptyTemplateData(), ...migrateV1Data(rawData) }),
  extraActions: (set, get) => ({
    setSubject: (subject) => {
      set({ data: { ...get().data, subject } });
    },

    setContent: (body) => {
      set({ data: { ...get().data, body } });
    },

    setRecipientsTo: (to) => {
      set({ data: { ...get().data, to: [...to] } });
    },

    setRecipientsCc: (cc) => {
      set({ data: { ...get().data, cc: [...cc] } });
    },

    setRecipientsBcc: (bcc) => {
      set({ data: { ...get().data, bcc: [...bcc] } });
    },

    setReplyTo: (replyTo) => {
      set({ data: { ...get().data, replyTo: [...replyTo] } });
    },

    setCredentialId: (credentialId) => {
      set({ data: { ...get().data, credentialId } });
    },

    getCredentialId: () => get().data.credentialId,

    // Override factory setTemplateData to run ensureDefaults
    setTemplateData: (data) => set({ data: ensureDefaults({ ...migrateV1Data(data) }) }),

    // Backward-compat aliases
    setEmailTemplate: (component) => get().setComponentData(component),
    setEmailName: (name) => set({ name }),
  }),
});

export { getEmailStore };
export default defaultStore;
